export default __webpack_public_path__ + "static/media/logo_croec.a0127fb3.jpg";